import React from 'react';
import * as S from './style';

const EmailField = ({email,setEmail, emailErrorMessage, setEmailErrorMessage, onEmailError }) => {

  const onChangeEmailCallback = (event) => {
    const val = event.target.value;
    setEmail(val);
  };

  React.useEffect(() => {
    if (emailErrorMessage && onEmailError) {
      onEmailError();
    } 
  }, [emailErrorMessage]);
  
  return (
    <>
      <S.InputLabel>EMAIL</S.InputLabel>
      <S.Input
        type="text"
        placeholder="example@domain.com"
        value={email}
        onChange={(e) => onChangeEmailCallback(e)}
        onBlur={(e) => setEmailErrorMessage(null)}
        isError={!!emailErrorMessage}
      />
      {emailErrorMessage && <S.Error>{emailErrorMessage}</S.Error>}
    </>
  );
};

export default EmailField;
